module.exports = __webpack_public_path__ + "img/LOGO-Klinik-Pratama-PKU-Kertek.02345f23.svg";